export default __webpack_public_path__ + "static/media/legend-mobile.b489c522.svg";